import { VwPluralPipe } from '../../../@commons/pipes/vw-plural.pipe';
import { VwNumberPipe } from '../../../@commons/pipes/vw-number.pipe';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from "../../../@commons/ui-components/shared.module";
import {
  CultivationNeeds
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@entities/cultivation-needs';
import { NeedItemComponent } from './need-item/need-item.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

/**
 * Valeurs d'énumération stockées soit en liste JSON (`'["SUNNY","VERY_SUNNY"]'`),
 * soit en valeur simple (`'VERY_SUNNY'`) selon la donnée : on accepte les deux.
 */
export function parseEnumList(value: unknown): string[] {
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  if (typeof value !== 'string' || !value.trim()) return [];
  const raw = value.trim();
  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
    } catch {
      return [];
    }
  }
  return [raw];
}

@Component({
  selector: 'vw-needs',
  imports: [
    SharedModule,
    NeedItemComponent,
    TranslatePipe,
    VwPluralPipe,
    VwNumberPipe,
  ],
  templateUrl: './needs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './needs.component.scss'
})
export class NeedsComponent {
  @Input() needs: CultivationNeeds;
  sizeIconUrl = 'assets/icons/plant-needs/size.svg';
  sunIconUrl = 'assets/icons/plant-needs/sun.svg';
  wateringIconUrl = 'assets/icons/plant-needs/watering.svg';
  soilIconUrl = 'assets/icons/plant-needs/soil.svg';
  spacingIconUrl = 'assets/icons/plant-needs/spacing.svg';

  constructor(private translate: TranslateService) {}

  /** Exposition traduite (« Ensoleillé, Très ensoleillé »). */
  get sunExposition(): string {
    return this.translateList(this.needs?.sun?.exposition, 'common.sunshine-levels');
  }

  /** Types de sol traduits. */
  get soilTypes(): string {
    return this.translateList(this.needs?.soil?.type, 'common.soil-types');
  }

  private translateList(value: unknown, prefix: string): string {
    return parseEnumList(value).map((v) => this.translate.instant(`${prefix}.${v}`)).join(', ');
  }
}
